import { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import focusManager from 'support/focus/FocusManager';
import { setRequestedFocusId } from 'actions/dialog';
import { VideoCtvRedux } from '../store-types';

export const useFocusManager = () => {
  const isDialogOpen = useSelector((state: VideoCtvRedux) => state.dialog.isOpen);

  const dispatch = useDispatch();
  const setCurrentFocus = (...args: [(string|number)?]) => {
    if (!isDialogOpen) {
      return focusManager.setCurrentFocus(...args);
    }

    const id: string | number | null | undefined = args[0];
    dispatch(setRequestedFocusId(id));

    return undefined;
  };

  const focusManagerRef = useRef(Object.create(focusManager));
  focusManagerRef.current.setCurrentFocus = setCurrentFocus;

  return focusManagerRef.current;
};
